import projectExecution from "@/assets/images/services/web-app/project-execution.webp";
import adminpanel from "@/assets/images/services/web-app/admin_panel.webp";
import apidesign from "@/assets/images/services/web-app/api_design.webp";
import teamlove from "@/assets/images/products/project-pulse/whychoose.webp";
import legacy from "@/assets/images/services/web-app/legacy.webp";

import Startup from "@/assets/images/services/web-app/startup.webp";
import Scaleup from "@/assets/images/services/web-app/scaleup.webp";
import Enterprise from "@/assets/images/services/web-app/enterprise.webp";
import pwa from "@/assets/images/services/web-app/pwa.webp";

import saas from "@/assets/images/services/web-app/saas.webp";

import appdevelopment from "@/assets/images/services/web-app/web_app.webp";

import scopeIcon from "@/assets/icons/services/web-app/scope.svg";
import planningIcon from "@/assets/icons/services/web-app/planning.svg";
import designIcon from "@/assets/icons/services/web-app/design.svg";
import agileIcon from "@/assets/icons/services/web-app/agile.svg";
import securityIcon from "@/assets/icons/services/web-app/security.svg";

import fintechIcon from "@/assets/icons/services/web-app/fintech.svg";
import edtechIcon from "@/assets/icons/services/web-app/edtech.svg";
import automativeIcon from "@/assets/icons/services/web-app/automative.svg";
import saasIcon from "@/assets/icons/services/web-app/saas.svg";
import ecommerceIcon from "@/assets/icons/services/web-app/ecommerce.svg";

const webAppServices = {
  "web-app-development": {
    slug: "web-app-development",
    name: "Web App Development",
    hero: {
      title:
        "Custom Web Applications Built to Automate, Scale & Simplify Your Business ",
      description:
        "From idea to deployment, we craft scalable, high-performance web applications that grow with your business. No templates. No shortcuts. Just clean code built for the real world. ",
      statitems: [
        {
          value: "200+",
          label: "Apps Delivered",
        },
        {
          value: "25+",
          label: "Industries Saved",
        },
        {
          value: "12+",
          label: "Countries Served",
        },
        {
          value: "50+",
          label: "Global Clients",
        },
      ],
    },

    process: {
      title: "How We Turn Your Vision into a Working Product",

      description:
        "From brief to browser in 6 focused steps. No hideouts. You see every decision and every milestone.",

      items: [
        {
          icon: scopeIcon,
          title: "Discovery & scope",
          description:
            "In-depth workshops to map user goals, workflows, and tech feasibility.",
        },

        {
          icon: planningIcon,
          title: "Architecture planning",
          description:
            "Right stack for scale and security with structured documentation.",
        },

        {
          icon: designIcon,
          title: "UI/UX design",
          description:
            "Clickable prototypes focused on usability and conversion.",
        },

        {
          icon: agileIcon,
          title: "Agile development sprints",
          description:
            "2-week sprint cycles with demos, QA feedback, and iterations.",
        },

        {
          icon: securityIcon,
          title: "QA & security hardening",
          description:
            "Automated tests, performance tuning, OWASP checks, and optimization.",
        },
      ],
    },

    industries: {
      title: "Real Results Across Industries",

      description:
        "Businesses across industries drive efficiency and growth with tailored digital platforms, smarter decisions, and streamlined operations.",

      items: [
        {
          title: "Fintech",
          desc: "Secure finance systems",
          icon: fintechIcon,
        },

        {
          title: "EdTech",
          desc: "Student-focused portals",
          icon: edtechIcon,
        },

        {
          image: "fintech",
        },

        {
          image: "industry",
        },

        {
          title: "Automotive",
          desc: "Factory & CRM platforms",
          icon: automativeIcon,
        },

        {
          title: "SaaS",
          desc: "Multi-cloud ready solutions",
          icon: saasIcon,
        },

        {
          image: "discuss",
        },

        {
          title: "eCommerce",
          desc: "Order & inventory systems",
          icon: ecommerceIcon,
        },
      ],
    },

    developmentpartner: {
      heading: "What Makes Us the Right Development Partner",
      description:
        "A practical, transparent approach focused on real-world solutions, built to scale without unnecessary complexity.",
      image: projectExecution,
      features: [
        {
          title: "We Build for Real Usage",
          description: "Apps designed for daily operations, not just demos",
        },
        {
          title: "Clear Communication",
          description: "Every decision explained in plain language",
        },
        {
          title: "Structured Delivery",
          description:
            "Fixed milestones, sprint demos, and predictable timelines",
        },
      ],
      floatfeatures: [
        {
          title: "No Over-Engineering",
          description: "We build what you need, nothing unnecessary",
        },

        {
          title: "Long-Term Thinking",
          description: "Architecture built to scale, not rebuild ",
        },
      ],
    },

    customwebapp: {
      title:
        "Custom Web Applications Built to Automate, Scale & Simplify Your Business ",
      subtitle:
        "End-to-end custom web apps built for your business, scalable, high-performance, and fully integrated. ",
      features: [
        {
          title: "Custom web app development",
          description:
            "Custom apps for your workflow, not CMS add-ons. Built with the right tech. ",
          image: appdevelopment,
        },
        {
          title: "Progressive Web Apps (PWA)",
          description:
            "App-store quality in the browser, offline-ready, installable, loads in under 2 seconds. ",
          image: pwa,
        },
        {
          title: "Legacy app modernization",
          description:
            "Save failing systems, rebuild, redesign, or migrate without disruption.",
          image: legacy,
        },
        {
          title: "API design & integrations",
          description: "API design & integrations",
          image: apidesign,
        },
        {
          title: "SaaS platform development",
          description:
            "Full SaaS backbone, multi-tenant, role-based, billing-ready from day one.",
          image: saas,
        },
        {
          title: "Dashboards & admin panels",
          description:
            "Real-time data, charts, and controls your team will use, not generic admin tools. ",
          image: adminpanel,
        },
      ],
    },

    businessgrowth: {
      title: "Technology Solutions for Every Stage of Business Growth",
      description:
        "Technology Solutions Built For Every Growth Stage, From MVPs To Enterprise Systems, Designed To Scale, Perform, And Evolve With Your Business.",
      growthCards: [
        {
          id: 1,
          title: "Startups",
          description:
            "Launch MVPs fast with a clear roadmap and scalable foundation ",
          image: Startup,
          rotate: -12,
        },
        {
          id: 2,
          title: "Scale-Ups",
          description:
            "Modernize legacy systems and build secure, high-performance platforms",
          image: Scaleup,
          rotate: 0,
        },
        {
          id: 3,
          title: "Enterprises",
          description:
            "Modernize legacy systems and build secure, high-performance platforms",
          image: Enterprise,
          rotate: 12,
        },
      ],
    },

    problemsolve: {
      title: "Operational Problems we solve with Custom Software",

      image: teamlove,
      cases: [
        {
          title: "Manual operations slowing your team",
        },
        {
          title: "Spreadsheet-based workflows causing errors",
        },
        {
          title: "Disconnected tools across departments",
        },
        {
          title: "Legacy systems blocking growth",
        },
        {
          title: "No real-time business visibility",
        },
        {
          title: "Performance issues during scale",
        },
        {
          title: "Inefficient internal workflows",
        },
      ],
    },
    cta: {
      title: "Discuss the web App",
      description:
        "Fill out the form to get the details. We’ll map the architecture, identify risks, and give you a clear, honest delivery estimate, no sales pitch, no obligation.",
      button: "Let's Talk",
    },

    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          question: "How long does it take to build a web app? ",
          answer:
            "Most projects are completed within 8–16 weeks depending on complexity. ",
        },
        {
          question: "Will I get updates during development? ",
          answer: "Yes. You’ll see progress every 2 weeks with working demos. ",
        },
        {
          question: "Do you handle both frontend and backend? ",
          answer: "Yes. We manage the full development cycle end-to-end. ",
        },
        {
          question: "Can you improve or rebuild an existing app? ",
          answer:
            "Absolutely. We can audit, fix, or completely rebuild systems. ",
        },
        {
          question: "What happens after launch? ",
          answer:
            "We provide support, monitoring, and optimization of post-launch. ",
        },
      ],
    },
  },
};
export default webAppServices;
